<template>
  <form>
    <v-text-field
      v-model="name"
      :error-messages="nameErrors"
      label="Nombre de la comunicacion"
      required
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
    ></v-text-field>
<v-select
      v-model="channel"
      :items="channels"
      :error-messages="channelErrors"
      label="Canal"
      required
      @change="$v.channel.$touch()"
      @blur="$v.channel.$touch()"
    ></v-select>
<v-select
      v-model="sender"
      :items="senders"
      item-text="sender_name"
      item-value="id"
      :hint="senderHint"
      :error-messages="senderErrors"
      label="Remitente"
      required
          persistent-hint
          return-object
          

      @change="$v.sender.$touch()"
      @blur="$v.sender.$touch()"
    ></v-select>

    <v-text-field
      v-model="email"
      :error-messages="emailErrors"
      label="E-mail"
      required
      @input="$v.email.$touch()"
      @blur="$v.email.$touch()"
    ></v-text-field>
    <ul>
        <li v-for="s in senders" :key="s.id">{{s.id}}</li>
    </ul>
    <v-checkbox
      v-model="checkbox"
      :error-messages="checkboxErrors"
      label="Do you agree?"
      required
      @change="$v.checkbox.$touch()"
      @blur="$v.checkbox.$touch()"
    ></v-checkbox>

    <v-btn @click="submit">submit</v-btn>
    <v-btn @click="clear">clear</v-btn>
  </form>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email } from 'vuelidate/lib/validators'

  import { mapGetters } from 'vuex'

  export default {
    mixins: [validationMixin],

    validations: {
      name: { required, maxLength: maxLength(256) },
      email: { required, email },
      channel: { required },
      sender: { required },
      checkbox: { required }
    },
    data: () => ({
      name: '',
      email: '',
      sender: null,
      channel: null,
      channels: [
        'email',
        'SMS'
      ],
      checkbox: false
    }),

    computed: {
    ...mapGetters(['senders']),
    senderHint() {
        return this.sender ? `de: "${this.sender.sender_name}" &lt;${this.sender.email_address}&gt;`: ''
    },
      checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        !this.$v.checkbox.required && errors.push('You must agree to continue!')
        return errors
      },
      channelErrors () {
        const errors = []
        if (!this.$v.channel.$dirty) return errors
        !this.$v.channel.required && errors.push('Especifique el tipo de canal')
        return errors
      },
      senderErrors () {
        const errors = []
        if (!this.$v.sender.$dirty) return errors
        !this.$v.sender.required && errors.push('Especifique cuenta de envio')
        return errors
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.name.required && errors.push('Name is required.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        return errors
      }
    },

    methods: {
      submit () {
        this.$v.$touch()
      },
      clear () {
        this.$v.$reset()
        this.name = ''
        this.channel = null
        this.sender = null
        this.email = ''
        this.select = null
        this.checkbox = false
      }
    }
  }
</script>